import {
  BehaviorSubject,
  catchError,
  filter,
  from,
  mergeMap,
  Observable,
  of,
} from 'rxjs';
import { Dependencies } from '../../../../configurations/dependencies/dependencies.interface';
import { Action, AnyAction } from '../../../state/action.type';
import { AppState } from '../../../state/app.state';
import {
  signOutFailure,
  signOutSuccess,
} from '../../../state/authentication/authentication.action';
import {
  SignOut,
  SIGN_OUT,
} from '../../../state/authentication/authentication.action.type';
import { AUTH_USECASE_ERROR_MESSAGES } from '../../errors/usecases.errorMessages/authenticationUsecase.error.messages';

export const signOutUsecase = (
  action$: Observable<Action>,
  _state$: BehaviorSubject<AppState>,
  dependencies: Dependencies,
): Observable<Action> =>
  action$.pipe(
    filter((action: AnyAction): action is SignOut => {
      return action.type === SIGN_OUT;
    }),
    mergeMap(() =>
      from(dependencies.oicdAuthenticatorGateway.signOut()).pipe(
        mergeMap(() => {
          return of(signOutSuccess());
        }),
        catchError((error: Error) => {
          console.warn('Signout Failed:', error);
          return of(
            signOutFailure(AUTH_USECASE_ERROR_MESSAGES.SIGN_OUT_FAILED),
          );
        }),
      ),
    ),
  );
